module.exports = __webpack_public_path__ + "img/UMKC-logo.10d73d43.png";